import IcomoonReact from 'icomoon-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import iconSet from './selection.json';

const IconLink = styled.a`
  cursor: pointer;
`;

const Icon = (props) => {
  const { color, size, icon, className, onClick, to, padding, customStyle } =
    props;

  // `to` renders a real router link (an <a href>) so cmd/ctrl-click and
  // "Open in new tab" work. Use `onClick` alone for non-navigation actions.
  if (onClick || to)
    return (
      <div
        style={{
          padding,
          display: 'inline-block',
          ...customStyle,
        }}
      >
        <IconLink as={to ? Link : undefined} to={to} onClick={onClick}>
          <IcomoonReact
            className={className}
            iconSet={iconSet}
            color={color}
            icon={icon}
            size={size}
          />
        </IconLink>
      </div>
    );

  return (
    <div style={{ padding, display: 'inline-block', ...customStyle }}>
      <IcomoonReact
        className={className}
        iconSet={iconSet}
        color={color}
        icon={icon}
        size={size}
      />
    </div>
  );
};

Icon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  padding: PropTypes.string,
  customStyle: PropTypes.object,
};

Icon.defaultProps = {
  className: '',
  color: '',
  size: '100%', // Default size
  onClick: null,
  to: null,
  padding: '0px',
  customStyle: {},
};

export default Icon;
